import american from '../assets/images/metodos-pago/crop_american.svg';
import binance from '../assets/images/metodos-pago/binance.svg';
import btc from '../assets/images/metodos-pago/btc.svg';
import eth from '../assets/images/metodos-pago/eth.svg';
import master from '../assets/images/metodos-pago/crop_mastercard.svg';
import paypal from '../assets/images/metodos-pago/paypal.svg';
import tether from '../assets/images/metodos-pago/tether.svg';
import visa from '../assets/images/metodos-pago/visa.svg';
import zelle from '../assets/images/metodos-pago/zelle.svg';
import zinli from '../assets/images/metodos-pago/zinli.svg';
import astropay from '../assets/images/metodos-pago/astropay.svg';
import pagoEfectivo from '../assets/images/PAGOEFECTIVO2.png';
import tupay from '../assets/images/metodos-pago/TUPAY.svg';
import nuvei from '../assets/images/metodos-pago/NUVEI.svg';
import better from '../assets/images/metodos-pago/better_pro.svg';
import coins from '../assets/images/ALPHAPO.svg';
import monnet from '../assets/images/metodos-pago/monnetpay.svg';
import valps from '../assets/images/metodos-pago/valps.svg'; 
import kushki from '../assets/images/metodos-pago/kushki.svg';
import bdv from '../assets/images/metodos-pago/bdvnew.svg';
import bnc from '../assets/images/metodos-pago/bncnew.svg';
import bfc from '../assets/images/metodos-pago/BFC.svg';
import pix from '../assets/images/metodos-pago/PIX (Brasil).svg';
import caja from '../assets/images/metodos-pago/Caja Vecina (Chile).svg';
import mercado from '../assets/images/metodos-pago/Mercado Pago (Argentina).svg';
import bancolombia from '../assets/images/metodos-pago/bancolombianew.svg';
import nequi from '../assets/images/metodos-pago/nequinew.svg';
import spei from '../assets/images/metodos-pago/SPEI (México).svg';
import banreservas from '../assets/images/metodos-pago/Banreservas (Rep Dominicana).svg';
import yappy from '../assets/images/metodos-pago/Yappy (Panamá).svg';
import revolut from '../assets/images/metodos-pago/Revolut (España).svg';
import wise from '../assets/images/metodos-pago/Wise (España).svg';

import cdesarrollo from '../assets/images/CAJADEDESARROLLO.svg';
import akisi from '../assets/images/AKISI.svg';
import bam from '../assets/images/BAM.svg';
import continental from '../assets/images/G&TContinental.svg';
import super24 from '../assets/images/SUPER24.svg';

import atlas from '../assets/images/metodos-pago/BANCO ATLAS - PARAGUAY.svg';
import bcontinental from '../assets/images/metodos-pago/BANCO CONTINENTAL - PARAGUAY.svg';
import bfamiliar from '../assets/images/metodos-pago/BANCO FAMILIAR - PARAGUAY.svg';
import itau from '../assets/images/metodos-pago/ITAÙ - PARAGUAY.svg';
import vision from '../assets/images/metodos-pago/VISION - PARAGUAY.svg';

export const methods = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "ALPHAPO",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "valps",
    src: valps,
    width: 60,
    height: 25
  },
  {
    name: "kushki",
    src: kushki,
    width: 60,
    height: 30
  },
  {
    name: "Monnet",
    src: monnet,
    width: 70,
    height: 20
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "zinli",
    src: zinli,
    width: 50,
    height: 18
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },{
    name: "astropay",
    src: astropay,
    width: 70,
    height: 25
  },{
    name: "pago efectivo",
    src: pagoEfectivo,
    width: 100,
    height: 30
  },{
    name: "nuvei",
    src: nuvei,
    width: 60,
    height: 25
  },{
    name: "tupay",
    src: tupay,
    width: 75,
    height: 25
  }
]

export const methodsPeru = [
  {
    name: "kushki",
    src: kushki,
    width: 60,
    height: 30
  },
  {
    name: "Monnet",
    src: monnet,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },{
    name: "pago efectivo",
    src: pagoEfectivo,
    width: 100,
    height: 30
  },{
    name: "tupay",
    src: tupay,
    width: 75,
    height: 25
  }
]

export const methodsVe = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "bdv",
    src : bdv,
    width: 70,
    height: 20,
  },
  {
    name: "bnc",
    src: bnc,
    width: 90,
    height: 30
  },
  {
    name: "bfc",
    src: bfc,
    width: 70,
    height: 20
  }
]

export const methodsBr = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "pix",
    src : pix,
    width: 70,
    height: 20,
  },
]

export const methodsCl = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "monnet",
    src: monnet,
    width: 70,
    height: 25
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "caja",
    src: caja,
    width: 70,
    height: 25
  },
  {
    name: "valps",
    src: valps,
    width: 70,
    height: 25
  },
]

export const methodsCo = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "bancolombia",
    src: bancolombia,
    width: 70,
    height: 30
  },
  {
    name: "nequi",
    src: nequi,
    width: 50,
    height: 25
  },
]

export const methodsAr = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "mercado",
    src: mercado,
    width: 70,
    height: 25
  },

]

export const methodsBo = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  }
]

export const methodsMx = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "spei",
    src: spei,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  }
]

export const methodsDo = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "banreservas",
    src: banreservas,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  }
]

export const methodsPa = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "yappy",
    src: yappy,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  }
]
export const methodsEs = [
  {
    name: "Better bro",
    src: better,
    width: 90,
    height: 20
  },
  {
    name: "Coins paid",
    src: coins,
    width: 70,
    height: 25
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "revolut",
    src: revolut,
    width: 70,
    height: 20
  },
  {
    name: "wise",
    src: wise,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  }
]

export const methodsGt = [
  {
    name: "valps",
    src: valps,
    width: 60,
    height: 25
  },
  {
    name: "Monnet",
    src: monnet,
    width: 70,
    height: 20
  },
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "G&T Continental",
    src: continental,
    width: 70,
    height: 30
  },
  {
    name: "Banco BAM",
    src : bam,
    width: 60,
    height: 30,
  },
  {
    name: "Caja de Desarrollo",
    src: cdesarrollo,
    width: 80,
    height: 30
  },
  {
    name: "Akisi Puedo",
    src: akisi,
    width: 60,
    height: 30
  },
  {
    name: "Super 24",
    src: super24,
    width: 60,
    height: 30
  }
]

export const methodsPy = [
  {
    name: "binance",
    src: binance,
    width: 90,
    height: 20
  },
  {
    name: "bitcoin",
    src: btc,
    width: 70,
    height: 20
  },
  {
    name: "tether",
    src: tether,
    width: 90,
    height: 25
  },
  {
    name: "ethereum",
    src: eth,
    width: 90,
    height: 25
  },
  {
    name: "paypal",
    src: paypal,
    width: 70,
    height: 20
  },
  {
    name: "american",
    src : american,
    width: 70,
    height: 30,
  },
  {
    name: "visa",
    src: visa,
    width: 60,
    height: 20
  },
  {
    name: "mastercard",
    src: master,
    width: 50,
    height: 25
  },
  {
    name: "Banco Atlas",
    src: atlas,
    width: 70,
    height: 30
  },
  {
    name: "Banco Continental",
    src : bcontinental,
    width: 70,
    height: 30,
  },
  {
    name: "Banco Familiar",
    src: bfamiliar,
    width: 70,
    height: 30
  },
  {
    name: "Banco Vision",
    src: vision,
    width: 70,
    height: 30
  },
  {
    name: "Itau",
    src: itau,
    width: 50,
    height: 30
  },
]